import React from "react";
import Card from "../../../Card";
import MUITextField from "@mui/material/TextField";
import MUIGrid from "@mui/material/Grid2";

export default function CardAdminPermissionGeneral(props) {
  const renderContent = () => (
    <MUIGrid container spacing={2}>
      <MUIGrid size={12}>
        <MUITextField
          value={props.permission ? (props.permission.name ?? "") : ""}
          autoFocus={true}
          size="small"
          label="Name"
          variant="standard"
          fullWidth={true}
          onBlur={(e) =>
            props.onChange({ name: (e.target.value || "").trim() })
          }
          onChange={(e) => props.onChange({ name: e.target.value })}
          required={true}
          error={props.validationIssues.name ? true : false}
          helperText={
            props.validationIssues.name ? props.validationIssues.name : ""
          }
          slotProps={{
            htmlInput: {
              maxLength: 255,
            },

            inputLabel: { shrink: true },
          }}
        />
      </MUIGrid>
      <MUIGrid size={12}>
        <MUITextField
          value={props.permission ? (props.permission.description ?? "") : ""}
          size="small"
          label="Description"
          variant="standard"
          fullWidth={true}
          multiline={true}
          minRows={2}
          maxRows={6}
          onBlur={(e) =>
            props.onChange({ description: (e.target.value || "").trim() })
          }
          onChange={(e) => props.onChange({ description: e.target.value })}
          slotProps={{
            htmlInput: {
              maxLength: 2000,
            },

            inputLabel: { shrink: true },
          }}
        />
      </MUIGrid>
    </MUIGrid>
  );

  return <Card renderContent={renderContent} getTitle={() => "General"} />;
}
